module.exports = __webpack_public_path__ + "static/media/foto_3.efb084bd.png";